<template>
  <div>
    <button class="btn-sms" :disabled="disabled || time > 0 || !phone" @click.prevent="handleClick">
      {{ text }}
    </button>
  </div>
</template>

<style lang="less" scoped>
.btn-sms {
  font-size: 30px;
  font-weight: 400;
  color: #0078ff;
  line-height: 42px;
  letter-spacing: 1px;
  min-width: 160px;
  word-break: keep-all;
  white-space: nowrap;
  background: transparent;
  &[disabled] {
    color: #999;
  }
}
</style>

<script>
export default {
  props: {
    phone: {
      type: String,
      required: true,
    },
    second: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      time: 0,
      disabled: false,
    };
  },
  computed: {
    text() {
      return this.time > 0 ? this.time + '秒后重试' : '获取验证码';
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    start() {
      this.time = this.second;
      this.timer();
    },
    stop() {
      this.time = 0;
      this.disabled = false;
    },
    setDisabled(val) {
      this.disabled = val;
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        this.disabled = false;
      }
    },
  },
};
</script>
